import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: { // all data
    UserSessionData: {},
    lastCheckInData: {
      CustomerID: null,
      VenueID: null
    },
    lastCheckInVenueID: null
  },
  mutations: {
    setUserSessionData(state, data) {
      state.UserSessionData = data;
    },
    setLastCheckInData(state, data) {
      state.lastCheckInData = data;
    },
    setCheckedInVenueID(state, id) {
      state.lastCheckInVenueID = id;
    },
  },
  getters: {
    getUserSessionData: (state) => {
      return state.UserSessionData;
    },
    getCheckedInVenueID: (state) => {
      return state.lastCheckInVenueID;
    },
    getLastCheckInData: (state) => {
      return state.lastCheckInData;
    }
  }
})
